import { useMutation, useQuery } from "@tanstack/react-query";

import {
  IActionResponse,
  IActionResult,
  SettingClient,
} from "../../services/proxies";
import { Module } from "../../assets/types";
import { SearchDto } from "../../assets/utils/lib/searchDto";
import { SettingTypeDto } from "./settingContainer";
import { Constants } from "../../assets/utils/lib/constants";

export class SettingService<T extends SettingTypeDto> {
  private settingClient: SettingClient<T>;
  public constructor(moduleType: Module) {
    this.settingClient = new SettingClient<T>(moduleType);
  }

  saveSetting = () =>
    useMutation<IActionResult<T>, Error, T>({
      mutationFn: async (payload: T) =>
        await this.settingClient.saveSettingAsync(payload),
    });

  getSettingQuery = (settingId: string | undefined) =>
    useQuery({
      queryKey: ["settingQuery", settingId],
      queryFn: async () => await this.settingClient.getSettingAsync(settingId),
      enabled: Boolean(settingId && settingId !== Constants.emptyGuid),
    });

  getSettingsQuery = () =>
    useQuery({
      queryKey: ["settingsQuery"],
      queryFn: async () => await this.settingClient.getSettingsAsync(),
    });

  gridQuery = (searchQuery: SearchDto) =>
    useQuery({
      queryKey: ["settingGridQuery", searchQuery],
      queryFn: async () =>
        await this.settingClient.searchSettingsAsync(searchQuery),
    });

  deleteSetting = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (settingId: string | undefined) =>
        await this.settingClient.deleteSettingAsync(settingId),
    });
}
